<!-- Foter -->
<footer class="footer pb-60">
	<div class="container flex flex-column sm:flex-row">

		<div class="flex-1 footer-box footer-left">
			<ul class="left-menu">
				<li (click)="navigation.goRules()">Regulamento</li>
				<li (click)="navigation.goNewList()" *ngIf="showRegister">Enviar Lista</li>
				<li (click)="navigation.goTerms()">Termos de uso</li>
				<li (click)="navigation.goEstatistics()">Estatísticas</li>
				<li (click)="navigation.goAbout()">Sobre</li>
			</ul>
		</div>

		<div class="flex-1 footer-box footer-center">
			<!-- Footer Logo -->
			<div class="mb-30 fadeInUp footer-logo">
				<a href="#top">
					<img src="assets/images/mascot.png" />
				</a>
			</div>
			<!-- End Footer Logo -->

			<!-- Footer Text -->
			<div class="footer-text">
				<div class="footer-made">
					-- desde 2011
				</div>
			</div>
			<!-- End Footer Text -->
		</div>

		<div class="flex-1 footer-box footer-right">
			<div class="footer-social-links">
				<a [href]="links.facebook" title="Facebook" target="_blank">
					<span><i class="fa-brands fa-facebook"></i></span>
				</a>
				<a [href]="links.twitter" title="Twitter" target="_blank">
					<span><i class="fa-brands fa-twitter"></i></span>
				</a>
				<a [href]="links.bluesky" title="Bluesky" target="_blank">
					<span><i class="fa-brands fa-bluesky"></i></span>
				</a>
			</div>
			<div class="pv-logo" *ngIf="showPvLogo"><img src="assets/images/zebras_white.png" title="Paulovelho" /></div>
			<div class="dev-mode" *ngIf="!!isDev">dev mode is <a (click)="turnOffDev()">on</a></div>
		</div>

	</div>


	<div class="local-scroll" *ngIf="showTopArrow">
		<a href="#top" class="link-to-top"><i class="fa fa-caret-up"></i><span class="sr-only">Scroll to top</span></a>
	</div>
	<!-- End Top Link -->

</footer>
<!-- End Foter -->